import type { FaireProductEntity } from "../../entity_types/product";

export const p_djy9d9zpzv: FaireProductEntity = {
  token: "p_djy9d9zpzv",
  type: "product",
  name: "GOLD PLATED BALL LINK SS NECKLACE",
  brandToken: "b_punhnqvhh6",
  brandName: "CRAVE",
  imageUrl:
    "https://cdn.faire.com/fastly/7c40896243eb103e5ccf00ccd143b2152ffd0d441191a80b786add8149eb0b80.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.9,
  description:
    'GOLD PLATED BALL LINK STAINLESS STEEL NECKLACE\nThickness: 12GA (2MM) OR 6GA (4MM) OR 4GA (5MM)\t\nLength: 24" OR 30"',
  tags: [],
  msrpDollars: 13.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:58.466Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
